import { generateActions } from './utils'
import { createAction } from 'redux-actions'

const registrationDefinition = {
  loadDivisions: ['scheduleId'],
  createRegistration: ['level', 'scheduleId', 'info'],
  getSettings: ['level', 'scheduleId'],
  updateRegistration: ['level', 'scheduleId', 'info'],
  updateDivision: ['scheduleId', 'info'],
  updateTeamRegStatus: [
    'scheduleId',
    'teamId',
    'scheduleRegistrationId',
    'status',
    'conditions',
    'conditionType',
    'divisionId',
    'teamRosterId',
  ],
  checkPayments: [],
}

export const registrationActions = generateActions(
  ['REGISTRATION'],
  registrationDefinition
)

// Simple actions (no saga needed)
export const SET_SCHEDULE_OWNER = 'REGISTRATION.SET_SCHEDULE_OWNER'
export const SET_TEAM_TO_CANCEL = 'REGISTRATION.SET_TEAM_TO_CANCEL'
export const TOGGLE_REGISTRATION_TAB = 'REGISTRATION.TOGGLE_REGISTRATION_TAB'
export const CLEAN_UP_PAYMENT_DATA = 'REGISTRATION.CLEAN_UP_PAYMENT_DATA'
export const UPDATE_REGISTRATION_SETTINGS =
  'REGISTRATION.UPDATE_REGISTRATION_SETTINGS'

export const setScheduleOwner = createAction(SET_SCHEDULE_OWNER)
export const setTeamToCancel = createAction(SET_TEAM_TO_CANCEL)
export const toggleRegistrationTab = createAction(TOGGLE_REGISTRATION_TAB)
export const cleanUpPaymentData = createAction(CLEAN_UP_PAYMENT_DATA)
export const updateRegistrationSettings = createAction(
  UPDATE_REGISTRATION_SETTINGS
)

export default registrationActions
